import {
  DEFAULT_GRID_COLOR,
  DEFAULT_PROJECT_LEVELS
} from '../utils/common_constants.js?v=20260706d';

export const S = {
  drawingSheets: null,

  project: {
    name: 'GMS Planner Projekt',
    systemType: 'multi_system',
    projectNumber: '',
    customerName: '',
    customerId: null,
    customerIdentityName: '',
    customerContactId: null,
    customerContactFirstName: '',
    customerContactLastName: '',
    customerContactName: '',
    orderNumber: '',
    orderDescription: '',
    seller: '',
    sellerUserId: null,
    avor: '',
    avorUserId: null,
    gridColor: DEFAULT_GRID_COLOR,
    gridSize: 10,
    helperGridSize: 600,
    showHelperGrid: false,
    snap: true,
    showGrid: true,
    currentView: 'plan',
    planLayerVisibility: { schemaVersion: 1, groups: {}, layers: {} },
    levels: { ...DEFAULT_PROJECT_LEVELS, bo: DEFAULT_PROJECT_LEVELS.db },
    floorplan: null,
    dimensions: [],
    obstacles: [],
    objectAssets: [],
    items: []
  },

  ui: {
    showLevelsPanel: false
  },

  selection: {
    items: [],
    groupId: null,
    unitId: null,
    unitIds: [],
    obstacleId: null,
    objectAssetId: null,
    objectAssetIds: [],
    sketchWall: { nodeId: null, wallId: null, angleId: null, openingId: null },
    sketchWallIds: []
  },

  history: {
    undo: [],
    redo: [],
    limit: 80
  },

  camera2D: {
    x: 0,
    z: 0,
    scale: 0.25
  },

  drag: {
    active: false,
    type: null,
    groupId: null,
    startMouse: null,
    startGroupPos: null,
    panStart: null,
    camStart: null,
    snapCandidate: null
  },

  view3d: {
    initialized: false,
    renderer: null,
    scene: null,
    camera: null,
    controls: { theta: -0.65, phi: 0.9, radius: 7000 },
    target: { x: 0, y: 900, z: 0 },
    insulation: {
      wall: { enabled: true, opacity: 0.56 },
      ceiling: { enabled: false, thickness: 80, opacity: 0.34 }
    },
    mouse: { down: false, x: 0, y: 0 }
  },

  floorplanMeasure: {
    active: false,
    referenceMm: '',
    points: []
  },

  file: {
    name: '',
    dirty: true
  }
};
